import { render, staticRenderFns } from "./join.item.vue?vue&type=template&id=fc6b2bae&scoped=true&"
import script from "./join.item.vue?vue&type=script&lang=js&"
export * from "./join.item.vue?vue&type=script&lang=js&"
import style0 from "./join.item.vue?vue&type=style&index=0&id=fc6b2bae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6b2bae",
  null
  
)

export default component.exports